import React, { useState } from "react";
import {
  Container,
  CustomTextAreaInput,
  HelperText,
  ImagePreview,
  ImageUploadCaption,
  ImageUploadCaptions,
  ImageUploadContainer,
  ImageUploadContentContainer,
  ImageUploadFileInput,
  ImageUploadText,
  InputContainer,
  Label,
} from "./styles";
import { IoMdCloudUpload } from "react-icons/io";

export default function ImageUpload({
  name,
  label,
  acceptedExtensions = [],
  imageSize = {
    height: null,
    width: null,
  },
  imageFile,
  imageUrl,
  errorMessage,
  disableAspectRatio = false,
  onChangeImageFile = () => null,
}) {
  const [previewImage, setPreviewImage] = useState('');

  const hasImageSize = Object.values(imageSize).every(Boolean);
  const hasImage = imageUrl || previewImage;

  const imageAspectRatio = hasImageSize
    ? imageSize.width / imageSize.height
    : "initial";

  const handleChangeImageFile = (e) => {
    const image = e.target.files[0];

    if(!image) {
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      setPreviewImage(reader.result);
      onChangeImageFile(image);
    };

    reader.readAsDataURL(image);
  };

  return (
    <Container>
      <Label htmlFor={name}>{label}</Label>
      <ImageUploadContainer>
        <ImageUploadContentContainer>
          <ImageUploadFileInput
            onChange={handleChangeImageFile}
            accept={acceptedExtensions.join(",")}
          />
          {!hasImage && (
            <>
              <IoMdCloudUpload size="3em" />
              <ImageUploadText>
                Arraste e solte aqui sua imagem ou clique para escolher do seu
                sistema
              </ImageUploadText>
            </>
          )}
          {hasImage && (
            <ImagePreview src={imageUrl || previewImage} imageAspectRatio={disableAspectRatio ? 'auto' : imageAspectRatio} />
          )}
        </ImageUploadContentContainer>
        <ImageUploadCaptions>
          {acceptedExtensions.length > 0 && (
            <ImageUploadCaption>
              <strong>Formatos suportados: </strong>
              {acceptedExtensions.join(", ")}
            </ImageUploadCaption>
          )}
          {hasImageSize && (
            <ImageUploadCaption>
              <strong>Tamanho sugerido: </strong>
              {imageSize.width} x {imageSize.height} pixels (recomendado)
            </ImageUploadCaption>
          )}
        </ImageUploadCaptions>
      </ImageUploadContainer>
      {errorMessage && <HelperText isError>{errorMessage}</HelperText>}
    </Container>
  );
}
